'use client';

import { useEffect } from 'react';
import { Button, Alert, AlertDescription, AlertTitle } from '@myapp/ui';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Page error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-6">
        <Alert variant="destructive" className="border-2">
          <AlertCircle className="h-5 w-5" />
          <AlertTitle className="text-lg">문제가 발생했습니다</AlertTitle>
          <AlertDescription className="mt-2 text-sm">
            {error.message || '예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'}
          </AlertDescription>
        </Alert>

        <div className="bg-muted/30 rounded-lg p-4 space-y-2">
          <p className="text-sm text-muted-foreground">
            이 문제가 계속되면 고객센터로 문의해주세요.
          </p>
          {error.digest && (
            <p className="text-xs text-muted-foreground font-mono">
              오류 코드: {error.digest}
            </p>
          )}
        </div>

        <div className="flex gap-3">
          <Button
            onClick={reset}
            className="flex-1"
            variant="default"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            다시 시도
          </Button>
          <Button
            onClick={() => router.push('/')}
            variant="outline"
            className="flex-1"
          >
            <Home className="w-4 h-4 mr-2" />
            홈으로
          </Button>
        </div>
      </div>
    </div>
  );
}